module.exports = __webpack_public_path__ + "img/微信.6c3bc871.png";